/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { createRoute } from '@gh/common-shared';
import { CmListComponent } from './components/cm-list/cm-list.component';
import { CmJobDetailsTabContainerComponent } from './components/cm-job-details/cm-job-details-tab-container.component';
import { JobDetailsBillingTabComponent } from './components/cm-job-details/job-details-billing-tab/job-details-billing-tab.component';
import { CmListBusinessService } from './resources/cm-list-business.service';
import { CmJobDetailsBusinessService } from './resources/cm-job-details-business.service';
import { CmWorksheetComponent } from './components/cm-worksheet/cm-worksheet.component';
import { JobBillingWorksheetBusinessService } from './resources/cm-worksheet-business.service';

const routes: Routes = [
  createRoute({
  component: CmListComponent,
  path: '',
  init: CmListBusinessService,
  auth: {
    permission: 'EventLog.VIEW',
  },
  }),
  createRoute({
    path: 'worksheet',
    init: JobBillingWorksheetBusinessService,
    component: CmWorksheetComponent,
    leave: true,
    auth: {
      permission: 'EventLog.VIEW',
    },
  }),
  createRoute({
    path: 'office/:officeId/billing-info/:jobId',
    init: CmJobDetailsBusinessService,
    component: CmJobDetailsTabContainerComponent,
    children: [
      createRoute({
        component: JobDetailsBillingTabComponent,
        path: 'billing',
      }),
    ],
  }),

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderCmRoutingModule {
}
